import { Directive, Input, AfterViewInit } from '@angular/core';
import { UnRx } from '@pebula/utils';
import { PblNgridComponent, PblDataSource, PblPaginatorChangeEvent } from '@pebula/ngrid';
import { Router, ActivatedRoute } from '@angular/router';

@Directive({
  selector: 'pbl-ngrid[sgStoreTableState]',
  standalone: false,
})
@UnRx()
export class SgStoreTableStateDirective<T = any> implements AfterViewInit {
  @Input() defaultPerPage: number;
  private dataSource;

  constructor(
    public cmp: PblNgridComponent<T>,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit(): void {
    this.dataSource = this.cmp.ds;
    if (this.route.snapshot.queryParamMap.has('tablePerPage')) {
      const tablePerPage = this.route.snapshot.queryParamMap.get('tablePerPage');
      this.dataSource.paginator.perPage = Number(tablePerPage);
    } else if (this.defaultPerPage) {
      this.dataSource.paginator.perPage = Number(this.defaultPerPage);
    }

    if (this.route.snapshot.queryParamMap.has('tablePage')) {
      const tablePage = this.route.snapshot.queryParamMap.get('tablePage');
      this.dataSource.paginator.total = Number(tablePage) * this.dataSource.paginator.perPage;
      this.dataSource.paginator.page = Number(tablePage);
    }
    this.dataSource.paginator.onChange.pipe(UnRx(this)).subscribe((event) => this.savePagination(event));
  }

  private savePagination(change: PblPaginatorChangeEvent): void {
    let queryParam;
    if (change.page && change.page[0] !== null) {
      queryParam = { tablePage: change.page[1] };
    } else if (change.perPage && change.perPage[0] !== null) {
      queryParam = { tablePerPage: change.perPage[1] };
    }

    if (queryParam) {
      this.router.navigate([], {
        queryParams: queryParam,
        queryParamsHandling: 'merge',
      });
    }
  }
}
